// Care Registry — open-ended Care Funds (no timeframes/quantities).

export const CAT = {
  MEALS: "🍲 Meals & Groceries · Care Fund",
  HOME: "🧹 A Little Help at Home · Care Fund",
  REST: "💛 Rest & Self-Care · Care Fund",
  PAMPER: "💆 Pampering & Small Joys · Care Fund",
  WELLNESS: "🌿 Recovery & Wellness · Care Fund",
  BODY: "🌿 Recovery & Bodywork · Care Fund",
};

export const ALL_ITEMS = [
  {
    id: "meals-14d",
    title: "Nourishing Postpartum Meal Fund",
    tag: CAT.MEALS,
    image: "https://images.pexels.com/photos/12050951/pexels-photo-12050951.jpeg",
    description:
      "Help keep the fridge stocked with iron-rich, warming, freezer-ready meals for the whole household.",
  },
  {
    id: "meals-family",
    title: "Family Meal Fund",
    tag: CAT.MEALS,
    image: "https://images.unsplash.com/photo-1547592180-85f173990554?auto=format&fit=crop&w=1200&q=80",
    description:
      "Fresh, made-from-scratch dinners for the whole household. Because siblings still need feeding, too.",
  },
  {
    id: "doula-day",
    title: "Postpartum Home Support Fund",
    tag: CAT.HOME,
    image: "https://customer-assets-4nw71qhi.emergentagent.net/job_held-wellbeing/artifacts/h66osyr6_doula.png",
    description:
      "Contributions toward hands-on support: newborn care, light tidying, laundry, warm meals, and dedicated listening.",
  },
  {
    id: "recovery-kit",
    title: "The Fourth Trimester Recovery Kit",
    tag: CAT.REST,
    image: "https://customer-assets-4nw71qhi.emergentagent.net/job_held-wellbeing/artifacts/jd69zjdk_recovery.png",
    description:
      "Peri bottle, witch hazel pads, cooling ice packs, nipple balm, high-protein snacks, and hydration essentials.",
  },
  {
    id: "cloud-robe",
    title: "Cloud Robe & Loungewear Set",
    tag: CAT.REST,
    image: "https://customer-assets-4nw71qhi.emergentagent.net/job_held-wellbeing/artifacts/07a0siga_Cloudrobe.webp",
    description:
      "Bamboo-cotton loungewear and nursing set, gentle on healing skin.",
  },
  {
    id: "therapy",
    title: "Postpartum Therapy Fund",
    tag: CAT.REST,
    image: "https://customer-assets-4nw71qhi.emergentagent.net/job_held-wellbeing/artifacts/i869xvda_therapy.png",
    description:
      "A quiet, warm, judgment-free space with a perinatal specialist to process, unload, and feel supported.",
  },
  {
    id: "lactation",
    title: "Lactation & Feeding Support",
    tag: CAT.WELLNESS,
    image: "https://customer-assets-4nw71qhi.emergentagent.net/job_held-wellbeing/artifacts/wjq1t8pp_Lactation%20.png",
    description:
      "Funding for professional, compassionate feeding consultations to support mum and baby.",
  },
  {
    id: "pelvic-physio",
    title: "Pelvic Floor & Recovery Care",
    tag: CAT.BODY,
    image: "https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?auto=format&fit=crop&w=1200&q=80",
    description:
      "Contributions toward specialized women's health physiotherapy and bodywork recovery.",
  },
  {
    id: "massage",
    title: "Postnatal Bodywork Fund",
    tag: CAT.PAMPER,
    image: "https://images.pexels.com/photos/18120171/pexels-photo-18120171.jpeg",
    description:
      "Warm oils, side-lying position, complete quiet — bodywork that helps her body remember it's held.",
  },
  {
    id: "mani-pedi",
    title: "Nails & Small Joys Fund",
    tag: CAT.PAMPER,
    image: "https://images.unsplash.com/photo-1610992015732-2449b76344bc?auto=format&fit=crop&w=1200&q=80",
    description:
      "Small quiet moments that are hers alone — a manicure, a pedicure, a slow morning.",
  },
];

export const PRIORITIES = [
  { id: "meals", label: "Meals & nourishment", hint: "Warming, iron-rich food delivered." },
  { id: "home", label: "A little help at home", hint: "Doula, tidying, laundry." },
  { id: "rest", label: "Rest & self-care", hint: "Recovery kits, loungewear, therapy." },
  { id: "pampering", label: "Pampering", hint: "Bodywork, nails, small joys." },
];

export const HERO_BANNER =
  "https://customer-assets-4nw71qhi.emergentagent.net/job_held-wellbeing/artifacts/w0it8fsl_Banner.png";
